// src/AdminLogin.js
import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';
import './Register.css'; // Import the CSS file for the Register page

const AdminLogin = () => {
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        email: '',
        password: '',
    });

    const [message, setMessage] = useState('');
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });

        // Clear the specific error for the field being updated
        if (errors[name]) {
            setErrors({ ...errors, [name]: '' });
        }
    };

    const validateForm = () => {
        const newErrors = {};
        if (!formData.email) newErrors.email = 'Email is required';
        if (!formData.password) newErrors.password = 'Password is required';
        return newErrors;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        console.log('Form submitted');
        console.log('Form data:', formData);

        const newErrors = validateForm();
        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            return;
        }

        setLoading(true);

        try {
            const response = await axios.post('https://simplyigbo-backend.onrender.com/api/admin/login', formData);
            console.log('Response:', response);
            if (response.status === 200) {
                setMessage('Login successful');
                setErrors({});
                // Store the token in cookies
                Cookies.set('token', response.data.token, { expires: 1, sameSite: 'Lax' }); // Expires in 1 day
                navigate('/admin'); // Redirect to admin dashboard on successful login
            }
        } catch (error) {
            console.error('Error:', error);
            if (error.response) {
                if (error.response.status === 404) {
                    setMessage('User not found');
                } else if (error.response.status === 401) {
                    setMessage('Invalid password');
                } else if (error.response.status === 403) {
                    setMessage('User is not verified');
                } else {
                    setMessage('Login failed');
                }
            } else if (error.code === 'ERR_NETWORK') {
                setMessage('Network error, please try again');
            } else {
                setMessage('Login failed');
            }
        } finally {
            setLoading(false);
        }
    };

    return (
        <section className="register-section">
            <div className="register-container" data-aos="fade-up">
                <h2 className="register-title" data-aos="fade-down">Admin Login</h2>
                <p className="register-subtitle" data-aos="fade-down">Please Enter Your Details To Login</p>
                <div className="register-content">
                    <div className="register-form-container" data-aos="fade-left">
                        <form onSubmit={handleSubmit}>
                            <div className="form-group">
                                <label htmlFor="email" className="form-label">Email Address</label>
                                <input
                                    type="email"
                                    id="email"
                                    name="email"
                                    className="form-input"
                                    value={formData.email}
                                    onChange={handleChange}
                                    required
                                />
                                {errors.email && <p className="error-message">{errors.email}</p>}
                            </div>
                            <div className="form-group">
                                <label htmlFor="password" className="form-label">Password</label>
                                <input
                                    type="password"
                                    id="password"
                                    name="password"
                                    className="form-input"
                                    value={formData.password}
                                    onChange={handleChange}
                                    required
                                />
                                {errors.password && <p className="error-message">{errors.password}</p>}
                            </div>
                            <div className="form-submit">
                                <button type="submit" className="form-button" disabled={loading}>
                                    {loading ? 'Loading...' : 'Login'}
                                </button>
                            </div>
                            {message && <p className='messagecolor'>{message}</p>}
                        </form>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default AdminLogin;